/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";
import { individualPaymentParcelViewModelSchema } from "../individualPaymentParcelViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200Schema =
  z.array(
    z.lazy(() => individualPaymentParcelViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsQueryResponse>;
